import { createContext, useContext, useEffect, useState } from 'react'
import type { Dispatch, ReactNode, SetStateAction } from 'react'

export interface Breadcrumb {
  label: string
  href?: string
}

interface BreadcrumbsState {
  breadcrumbs: Breadcrumb[]
  setBreadcrumbs: Dispatch<SetStateAction<Breadcrumb[]>>
}

export const BreadcrumbsContext = createContext<BreadcrumbsState>({
  breadcrumbs: [],
  setBreadcrumbs: () => {},
})

export function BreadcrumbsProvider({ children }: { children: ReactNode }) {
  const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>([])
  return (
    <BreadcrumbsContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbsContext.Provider>
  )
}

export function useSetBreadcrumbs(crumbs: Breadcrumb[]): void {
  const { setBreadcrumbs } = useContext(BreadcrumbsContext)
  // Serialize crumbs as dep so the effect only fires when the label/href values change,
  // not when the caller recreates the array reference on every render.
  const serialised = crumbs.map((c) => `${c.label}|${c.href ?? ''}`).join(',')
  useEffect(() => {
    setBreadcrumbs(crumbs)
    return () => setBreadcrumbs([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serialised])
}
